<template>
    <div class="breedingPig">
        <h3>{{detail.title}}</h3>
    <!-- 关键生产指标分析 -->
        <div class="part">
            <h4>关键生产指标分析</h4>
            <van-row class="production">
                <van-col span="8">
                    <div> {{detail.feedDays}}<span>天</span> </div>
                    <span>饲养天数</span>
                </van-col>
                <van-col span="8">
                    <div> {{detail.weightOfDay}}<span>g/天</span> </div>
                    <span>日增重</span>
                </van-col>
                <van-col span="8">
                    <div> {{detail.meatFeedProportion}}</div>
                    <span>料肉比</span>
                </van-col>
            </van-row>
            <van-row class="production">
                <van-col span="8">
                    <div> {{detail.positiveRate}}<span>%</span> </div>
                    <span>正品率</span>
                </van-col>
                <van-col span="8">
                    <div> {{detail.deadRate}}<span>%</span> </div>
                    <span>死淘率</span>
                </van-col>
            </van-row>
            <div class="line"></div>
            <p class="pro-list">{{detail.feedDaysDesc}}</p>
            <p class="pro-list">{{detail.weightOfDayDesc}}</p>
            <p class="pro-list">{{detail.meatFeedProportionDesc}}</p>
            <p class="pro-list">{{detail.positiveRateDesc}}</p>
            <p class="pro-list">{{detail.deadRateDesc}}</p>
        </div>
    <!-- 生产成本分析 -->

    <!-- 预防分析 -->
        <div class="part preven">
            <h4>预防分析</h4>
            <p v-for="vacc in detail.vaccineList" :key="vacc">{{vacc}}</p>
            <p v-if="detail.vaccineList.length == 0" class="no-info">暂无数据</p>
            <p class="succ" v-else>以上疫病免疫更好，建议进行疫苗免疫效果评估，了解猪群更健康</p>

            <!-- <p v-for="yferr in info.yffxErr" :key="yferr">{{yferr}}</p>
            <p class="err">以上疫苗未免疫，以上疫病未按程序进行免疫，存在疫病风险，建议进行检查或加强免疫！</p> -->
        </div>
        
        <div class="part health" v-if="detail.healthCareDesc != null">
            <h4>保健分析</h4>
            <p>{{detail.healthCareDesc}}</p>
        </div>

        <div class="part disinfect">
            <h4>消毒分析</h4>
            <p class="dis-all">{{detail.disinfectionNum}}</p>
            <p v-if="detail.disinfectionNum == null" class="no-info">本阶段没有做任何检测！</p>
            <p v-else v-for="disin in detail.disinfectionDesc" :key="disin">{{disin}}</p>
        </div>

        <div class="part test">
            <h4>检测分析</h4>
            <p v-if="detail.checkList.length == 0" class="no-info">本阶段没有做任何检测！</p>
            <p v-else v-for="check in detail.checkList" :key="check">{{check}}</p>
        </div>

        <div class="part synthesize">
            <h4>综合分析</h4>
            <div class="status">
                <p>{{detail.complexBTNRate}}</p>
                <p>整体健康状况：<span>{{detail.complexRating}}</span></p>
            </div>
        </div>
    </div>
</template>

<script>
import { GetStageReport} from '@/api/resetApi.js'
import { Toast } from 'vant';
export default {
    name:'breedingPig',
    data(){
        return{
            dossierId:null,
            stageType:null,
            detail:{
                vaccineList:[],
                checkList:[]
            }
        }
    },
    created(){
        this.dossierId = this.$route.query.dossierId
        this.stageType = this.$route.query.stageType
        localStorage.setItem('utoken',this.$route.query.uToken)
        localStorage.setItem('sysCode',this.$route.query.sysCode)

        this.getStageReport()
    },
    methods:{
        async getStageReport(){
            let data = {
                dossierId:this.dossierId,
                stageType:this.stageType
            }
            let res = await GetStageReport(data)
            try {
                if (res.data.code === 200) {
                    this.detail = res.data.data
                }else{
                    Toast(res.data.msg)
                }
            } catch (error) {
                
            }
        },
    }
}
</script>

<style lang="scss" scoped>
    .breedingPig{
        font-size: 14px;
        padding: 30px 15px;
        background: #26B798;
        color: #4A4A4A;
        text-align: left;
        p{
            line-height: 25px;
        }
        .no-info{
            text-align: center;
            color:#EA4747;
            line-height: 24px;
            margin: 8px 0;
        }
        h3{
            font-size: 16px;
            color: #fff;
            text-align: center;
            line-height: 44px;
        }
        .part{
            padding: 16px 10px 16px 14px;
            background: #fff;
            border-radius: 16px;
            margin-bottom: 12px;
            h4{
                text-align: center;
                font-size: 16px;
                color: #181818;
                margin-bottom: 18px;
                font-weight: bold;
            }
            .pro-list{
                text-align: left;
                line-height: 30px;
            }
            .line{
                width: 100%;
                border-bottom: 1px solid #26B798;
                position: relative;
                margin-bottom: 12px;
                &:after,&:before{
                    display: inline-block;
                    content: "";
                    width:9px;
                    height:9px;
                    background:rgba(38,183,152,1);
                    position: absolute;
                    transform: rotate(45deg);
                    top: -4px;
                }
                &:before{
                    right: 0;
                }
            }
        }
        .production{
            margin-bottom: 20px;
            .van-col{
                text-align: center;
                &>div{
                    color: #26B798;
                    font-size: 18px;
                    margin-bottom: 12px;
                    span{
                        font-size: 14px;
                    }
                }
            }
        }
        .preven{
            p{
                line-height: 30px; 
            }
            .succ{
                color: #26B798;
                line-height: 26px;
                margin: 14px 0;
            }
            .err{
                color: #EA4747;
                line-height: 26px;
                margin-top: 20px
            }
        }
        .disinfect{
            .dis-all{
                margin-bottom: 10px;
            }
        }
        .synthesize{
            .status{
                p{
                    line-height: 24px;
                    span{
                        color: #26B798
                    }
                }
            }
        }
    }
</style>